import * as yup from 'yup';

export const addTrialDaysSchema = yup.object().shape({
  store_alias_id: yup.string().required('Este campo é obrigatório.'),
  days_to_add: yup.string().required('Este campo é obrigatório.'),
});
